// 事件留存
import request from '@/utils/request';
export function eventRetain(data) {
  return request({
    url: '/data/eventRetain',
    method: 'get',
    params: data
  });
} //自定义玩法

export function playerRetain(data) {
  return request({
    url: '/data/playerRetain',
    method: 'get',
    params: data
  });
}
export function eventActionFunnel(data) {
  return request({
    url: '/data/event-action-funnel',
    method: 'get',
    params: data
  });
}